<template>
  <div>
    666
  </div>
</template>
   
<script>
export default {
  data(){
    return {
    }
  },
  created() {
  },
  methods: {
  
  },
}
</script>
   
<style scoped lang='scss'>
  
</style>